<script lang="ts">
	import { onMount } from 'svelte';
	import { replace, querystring } from 'svelte-spa-router';
	import { fillMissingUnitNames, parseQuerystring, wait } from 'src/helpers/utilities';
	import { user_data } from 'src/stores/account/user';
	import { standardLogin } from 'src/services/http';
	import { AlertV2, Loader, Text, toast } from '@Shelly/shelly-design-system';
	import { setUpI18n } from 'src/services/i18n';
	import { handleUserProfile } from 'src/helpers/login_helpers';
	import { handleLoginErrors } from 'src/helpers/account_helpers';
	import sha1 from 'crypto-js/sha1';
	import { profiles } from 'src/stores/features/profiles';
	import { onChangeProfile } from 'src/components/Profiles/profiles_helpers';
	import { format } from 'src/services/i18n';
	import { isMultiUnitResult, nativeLogin } from 'src/services/auth_v2';
	import { normalizeEmail } from 'src/helpers/email_helpers';

	let { email, pass, unit } = parseQuerystring($querystring);

	let error = false;
	let loading = false;
	let alertProps = {
		heading: 'We have encountered an error.',
		message: 'An error occurred while trying to log in. Please try again.',
	};

	onMount(async () => {
		// Normalize email to lowercase to ensure consistent handling across the app
		email = normalizeEmail(email);

		if ($profiles.length >= 5) {
			await onChangeProfile($profiles[0].email, $profiles[0].id);
			toast.open({
				type: 'info',
				title: $format('alert_title_profile_limit_reached', {
					default: 'Profiles limit reached',
				}),
				text: $format('alert_text_profiles_limit_reached', {
					default: `You can not log in with more than 5 accounts at a time.`,
				}),
			});
			replace('/');
		} else if ($user_data.email && $user_data.email === email && pass) {
			toast.open({
				type: 'info',
				title: 'Already Logged In',
				text: 'You are already logged in. Redirecting you to the home page.',
			});
			replace('/');
		} else if (email && pass) {
			loading = true;
			let hashPass = sha1(pass).toString();
			let res = await standardLogin(email, hashPass, unit);

			if (res?.isok && isMultiUnitResult(res)) {
				const hasTokens = res.accessToken && res.refreshToken;

				if (!unit && !hasTokens) {
					res = await standardLogin(email, hashPass, String(res.selectedUnitId));
				}
			}

			if (res?.isok) {
				nativeLogin(
					email,
					res.data.password,
					res.data.user_api_url,
					res.data.token,
					res.data.lang,
				);

				await setUpI18n(res.data.lang);

				await wait(1000);
				await handleUserProfile(hashPass);
			} else {
				error = true;
				alertProps = handleLoginErrors(res);
			}

			loading = false;
		} else {
			error = true;
		}
	});
</script>

<!-- <Container type="modalContainer" class="d-flex align-items-center width-full"> -->
{#if loading}
	<Text class="d-flex justify-content-center mb-m">{'Logging you in.'}</Text>
	<Loader size="l" class="d-flex justify-content-center mb-m" />
{:else if error}
	<AlertV2 class="mb-m" type="danger" heading={alertProps.heading} message={alertProps.message} />
{/if}
<!-- </Container> -->
